export default {
      id: "ic-plan-territoire-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-territoire-usage",
      toString: function () {
        return this.url;
      }
    }